import React, { useState } from "react";
import { motion } from "framer-motion";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "./Contact.css";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await addDoc(collection(db, "contacts"), {
      ...form,
      createdAt: new Date()
    });

    alert("🚀 Message Sent Successfully!");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact-section">

      <div className="animated-bg"></div>

      <motion.h1
        className="main-title"
        initial={{ opacity: 0, y: -60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Connect With <span>TraviRa</span>
      </motion.h1>

      <div className="contact-grid">

        {/* Company Info */}
        <motion.div
          className="info-card glass"
          initial={{ opacity: 0, x: -120 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>About Our Company</h2>
          <p>
            TraviRa Software Solutions builds AI-powered web & mobile platforms
            for modern businesses worldwide.
          </p>

          <div className="info-item">📍 Chennai, India</div>
          <div className="info-item">📧 support@travira.com</div>
          <div className="info-item">📞 +91 7296000101</div>

          <iframe
            title="map"
            src="https://maps.google.com/maps?q=chennai&t=&z=13&ie=UTF8&iwloc=&output=embed"
            className="map"
          ></iframe>
        </motion.div>

        {/* Contact Form */}
        <motion.form
          className="form-card glass"
          onSubmit={handleSubmit}
          initial={{ opacity: 0, x: 120 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={form.message}
            onChange={handleChange}
            required
          />

          <motion.button
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            type="submit"
          >
            Send Message 🚀
          </motion.button>
        </motion.form>

      </div>
    </div>
  );
}

export default Contact;